import React from 'react'
import R from 'ramda'

import DoubleInputRange from './DoubleInputRange'

const PriceRange = ({validValues, max, min, onChange, onUpdate}) => {
  return <DoubleInputRange
    validValues={validValues}
    minValue={min}
    maxValue={max}
    onChange={(values) => onChange(values)}
    onUpdate={(values) => onUpdate(values)}/>
}

export default PriceRange



/** WEBPACK FOOTER **
 ** ./app/components/PriceRange.jsx
 **/